export var EColorPreference;
(function (EColorPreference) {
    EColorPreference["NONE"] = "NONE";
    EColorPreference["LIGHT"] = "LIGHT";
    EColorPreference["DARK"] = "DARK";
})(EColorPreference || (EColorPreference = {}));
;
